import React, { useRef, useState, useEffect, forwardRef, useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux"
import {
  Box, List,
  ListItemText,
  ListItemButton,
  IconButton,
  useTheme,
  Button
} from "@mui/material";
import FolderIcon from '@mui/icons-material/Folder';
import HomeIcon from '@mui/icons-material/Home';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import AddchartOutlinedIcon from '@mui/icons-material/AddchartOutlined';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import SummarizeIcon from '@mui/icons-material/Summarize';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import Snackbar from '@mui/material/Snackbar';
import Spinner from '../../components/Spinner'
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { usePbiLoginMutation, usePbiGetTenantDetailsMutation, usePbiGetUserDetailsMutation, usePbiGetFoldersMutation, usePbiReportDetailsMutation, usePbiReportListWithFolderMutation, usePbiMoveFolderReportMutation, usePbiMoveFolderMutation, usePbiDeleteFolderMutation, usePbiDeleteReportMutation, usePbiReportListMutation } from '../auth/authApiSlice'
import AddUpdateFolder from '../../components/addnewfolder'
import { setPBICredentials, setUserPreference, setTenantWorkspace, setTenantWorkspacelist, setReportSelectedIndex, setSelectedReportDetails, selectCurrentUser, setSelectedReportId, selectPBIWorkspace, selectPBIWorkspaceList } from "../auth/authSlice"
import { setUserData, setPBIFolderList, setReportId, setPBIReportFolderList, selectUserData, selectPBIFolderList, selectReportFolderList, setIsStandardDB, selectIsAdminAnalytics } from "../data/dataSlice"
import { useNavigate } from "react-router-dom";
import AlertDeleteDialog from './DeleteDialog';
import { tokens } from "../../assets/theme";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Checkbox from '@mui/material/Checkbox';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Item = styled(Paper)(({ theme }) => ({
  // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : 'none',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const FolderDashboard = (props) => {
  const dispatch = useDispatch()
  const user = useSelector(selectCurrentUser)
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const reportList = useSelector(selectReportFolderList)
  const isAdminAnalytics = useSelector(selectIsAdminAnalytics);
  let reportListfilter;
  const [pbiDeleteReport, { isPBIDeleteReportLoading }] = usePbiDeleteReportMutation()

  const reportSelectedID = useSelector(setTenantWorkspace)
  const navigate = useNavigate()
  const [pbiLogin, { isPBILoading }] = usePbiLoginMutation()
  const [pbiGetTenantDetails, { isPBITenantLoading }] = usePbiGetTenantDetailsMutation()
  const [pbiGetUserDetails, { isPBIGetUserLoading }] = usePbiGetUserDetailsMutation()
  const [pbiMoveFolderReport, { isPBIMoveFolderReportLoading }] = usePbiMoveFolderReportMutation()
  const [pbiMoveFolder, { isPBIMoveFolderLoading }] = usePbiMoveFolderMutation()
  const [pbiDeleteFolder, { isPBIDeleteFolderLoading }] = usePbiDeleteFolderMutation()
  const [pbiPasteReport, { isPBIPasteReportLoading }] = usePbiMoveFolderReportMutation()
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [spinnerLoad, setSpinnerLoad] = useState(false)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [errMsg, setErrMsg] = useState('')
  const pbiworkspace = useSelector(selectPBIWorkspace)
  const currentUserData = useSelector(selectUserData);

  const [pbiGetFoldersMutation, { isPbiGetFoldersLoading }] = usePbiGetFoldersMutation()
  const [pbiReportListWithFolder, { isPBIReportWithFolderLoading }] = usePbiReportListWithFolderMutation()
  const [pbiReportDetails, { isPBIReportDetailsLoading }] = usePbiReportDetailsMutation()
  const userdata = useSelector(selectUserData)
  const workspaces = useSelector(selectPBIWorkspaceList)
  const [currentUser, setCurrentUser] = useState(null)
  const [currentWorkSpace, setCurrentWorkSpace] = useState(null)

  useEffect(() => {
    setCurrentUser(userdata)
  }, [userdata])

  useEffect(() => {
    setCurrentWorkSpace(workspaces)
  }, [workspaces])

  const handleGetFolders = async (data) => {
    const userid = { "userID": data ? data.id : "" }
    const resData = await pbiGetFoldersMutation(userid).unwrap()
    if (resData) {
      dispatch(setPBIFolderList(resData))
    }
  }


  const handlePBIReportListWithFolder = async (workspacedetails) => {
    try {
      setSpinnerLoad(true)
      let workspaceid = { "workspaceId": workspacedetails, "IsUserReportPermission": !isAdminAnalytics }
      // setSpinnerLoad(true)
      const getReportList = await pbiReportListWithFolder(workspaceid).unwrap()
      if (getReportList && getReportList.reports) {
        let sortedReportList = getReportList.reports.slice().sort((a, b) => a.name.localeCompare(b.name))
        dispatch(setPBIReportFolderList(sortedReportList))
      }
      setSpinnerLoad(false)
    } catch (err) {
      console.log(err)
      setSpinnerLoad(false)
    }
  }

  useEffect(() => {
    if (userdata) {
      handleGetFolders(userdata)
    }
  }, [currentUser])
  useEffect(() => {
    if (workspaces && workspaces.length > 0) {
      handlePBIReportListWithFolder(workspaces[0].workspaceId)
    }
  }, [currentWorkSpace])

  let folderList = useSelector(selectPBIFolderList);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [folderBreadCrum, setFolderBreadCrum] = useState([]);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [isIdenticalFolder, setIsIdenticalFolder] = useState(false);
  const [folderMoveDetails, setFolderMoveDetails] = useState(null);
  const [currentContextFolder, setCurrentContextFolder] = useState(null);
  const [isIdenticalReport, setIsIdenticalReport] = useState(false);
  const [reportMoveDetails, setReportMoveDetails] = useState(null);
  const [isMoveFolder, setIsMoveFolder] = useState(false);
  const [currentContextReport, setCurrentContextReport] = useState(null);
  const [isSharedFolder, setIsSharedFolder] = useState(0);
  const [openAddUpdateFolder, setOpenAddUpdateFolder] = useState(false);
  const [isFolderClick, setIsFolderClick] = useState(false);
  const [isReportClick, setIsReportClick] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackbarDelete, setOpenSnackbarDelete] = useState(false);
  const [pbiReportList, { isPBIReportLoading }] = usePbiReportListMutation()
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteAction, setDeleteAction] = useState('');
  const [RenameFolder, setRenameFolder] = useState(false);
  const [moveReport, setMoveReport] = useState(false);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (props.selectedReport !== '') {
      reportList && reportList.filter((report) => {
        folderList && folderList.filter((folder) => {
          if (report.reportId == props.selectedReport && report.folderId == folder.folderId) {
            setCurrentFolder(folder);
            let folderPath = handleBreadCrumPath(folder.folderId);
            setFolderBreadCrum(folderPath);
          }
        })
      })
    }
  }, [props.folder]) //reportList, folderList

  const handleBreadCrumPath = (folderId) => {
    const folder = folderList && folderList.find(item => item.folderId === folderId);
    if (!folder) return [];
    const folderPath = [folder];
    if (folder.parentId) {
      const parentFolderPath = handleBreadCrumPath(folder.parentId);
      if (parentFolderPath && parentFolderPath.length > 0) {
        folderPath.unshift(...parentFolderPath);
      }
    }
    return folderPath;
  }

  const handleFolderClick = useCallback((e, folderdata) => {
    e.preventDefault();
    if (e.type == 'click') {
      let folderPath = handleBreadCrumPath(folderdata.folderId);
      setFolderBreadCrum(folderPath);

      if (folderdata.folderId == 1 && folderdata.parentId == 0) {
        setIsSharedFolder(1)
      }
      if (folderdata.folderId == 2 && folderdata.parentId == 0) {
        setIsSharedFolder(0)
      }
    }
  })

  const handleFolderAction = (e, folderdata) => {
    e.preventDefault();
    handleClick(e);
    setCurrentContextFolder(folderdata);
    setIsFolderClick(true);
    setIsReportClick(false);
    if (folderMoveDetails && folderMoveDetails.folderId == folderdata.folderId) {
      setIsIdenticalFolder(true);
    } else {
      setIsIdenticalFolder(false);
    }
  }

  const handleReportClick = useCallback((e, reportdata) => {
    e.preventDefault();
    if (e.type == 'click') {
    }
  })

  const handleReportAction = (e, reportdata) => {
    e.preventDefault();
    setCurrentContextReport(reportdata);
    setIsReportClick(true);
    setIsFolderClick(false);
    handleClick(e);
    if (reportMoveDetails && reportMoveDetails.reportId == reportdata.reportId) {
      setIsIdenticalReport(true);
    } else {
      setIsIdenticalReport(false);
    }
  }

  const handleMoveFolderClick = (e) => {
    e.preventDefault();
    setIsMoveFolder(true);
    setReportMoveDetails(null);
    setFolderMoveDetails(currentContextFolder);
  }


  const handlePasteFolderClick = async (e) => {
    e.preventDefault();
    const reqdata = { "FolderId": folderMoveDetails && folderMoveDetails.folderId, "SourceParentId": folderMoveDetails && folderMoveDetails.parentId, "DestinationParentId": currentContextFolder && currentContextFolder.folderId }
    const resData = await pbiMoveFolder(reqdata).unwrap()
    if (resData) {
      handleGetFolders(currentUserData);
      setOpenSnackbar(true);
      setReportMoveDetails(null); //currentContextReport
      setFolderMoveDetails(null);
      setIsMoveFolder(false);
    }
  }

  const handleDeleteFolderAlert = (e) => {
    e.preventDefault();
    setOpenDialog(true);
    setDeleteAction('folder');
  }
  const handleDeleteFolderClick = async () => {
    folderList = folderList.filter((folders) => folders.folderId == currentContextFolder.folderId)

    const reqdata = folderList.map((val) => {
      return { "FolderId": val.folderId, "SourceParentId": val.parentId }
    })
    const resData = await pbiDeleteFolder(reqdata[0]).unwrap()
    setOpenDialog(false);
    setDeleteAction('');
    if (resData) {
      handleGetFolders(currentUserData);
      setOpenSnackbarDelete(true);

    }
    setTimeout(() => {
      setOpenSnackbarDelete(false);
    }, 3000);

  }

  const handleDleteAlertClose = () => {
    setOpenDialog(false);
  }
  const handleDeleteReportAlertClick = (e) => {
    e.preventDefault();
    setOpenDialog(true);
    setDeleteAction('report');
  }

  const handleDeleteReport = async () => {
    let logggedInDetails = { "loginId": user }
    const getTenantDetails = await pbiGetTenantDetails(logggedInDetails).unwrap()
    let reportListfilter = reportList.filter((report) => report.reportId === currentContextReport.reportId)
    const reqdata = reportListfilter.map((val) => {
      return { "reportId": val.reportId, "workspaceId": getTenantDetails[0].workspaceId }
    })
    const resData = await pbiDeleteReport(reqdata[0]).unwrap()
    setOpenDialog(false);
    setDeleteAction('');
    if (resData) {
      handleGetFolders(currentUserData);
      handlePBIReportListWithFolder(getTenantDetails[0].workspaceId)
      //setOpenSnackbar(true);
      setReportMoveDetails(null);
      setFolderMoveDetails(currentContextReport);
    }

    // setTimeout(() => {
    //   setOpenSnackbarDelete(false);
    // }, 3000);
  }


  const handleMoveReportClick = (e) => {
    e.preventDefault();
    setFolderMoveDetails(null);
    setReportMoveDetails(currentContextReport);
    setMoveReport(true);
  }

  const handlePasteReportClick = async (e) => {
    e.preventDefault();
    let logggedInDetails = { "loginId": user }
    const getTenantDetails = await pbiGetTenantDetails(logggedInDetails).unwrap()
    const reqdata = {
      "reportId": selected.length > 0 ? selected : [reportMoveDetails.reportId],
      "tenantId": getTenantDetails[0].workspaceId,
      "sourceFolderId": reportMoveDetails && reportMoveDetails.folderId,
      "destinationFolderId": currentContextFolder && currentContextFolder.folderId
    }

    const resData = await pbiMoveFolderReport(reqdata).unwrap()
    if (resData) {
      handleGetFolders(currentUserData);
      handlePBIReportListWithFolder(getTenantDetails[0].workspaceId)
      let updatedBreadceumPath = handleBreadCrumPath(currentContextFolder.folderId);
      setCurrentFolder(currentContextFolder)
      setFolderBreadCrum(updatedBreadceumPath);
      setSelected([])
      // setOpenSnackbar(true);
      setReportMoveDetails(null);
      setFolderMoveDetails(null);
      setMoveReport(false);
    }
  }



  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const handleBreadCrumbClick = indexvalue => {
    setFolderBreadCrum(folderBreadCrum.splice(0, indexvalue + 1))
  }

  const handleOpenAddUpdateFolder = (e) => {
    e.preventDefault();
    setOpenAddUpdateFolder(true);
  }

  const handleRenameFolder = (e) => {
    e.preventDefault();
    setRenameFolder(true);
    setOpenAddUpdateFolder(true);
    setCurrentContextReport(currentContextReport);
  }
  const handleOpenReportClick = async (reportid, workspacedetails, index) => {
    if (reportSelectedID != reportid) {
      //dispatch(setReportFilters(null))
      localStorage.setItem('reportrendered', JSON.stringify("false"));
      localStorage.setItem('filterdata', JSON.stringify([]));
    }
    dispatch(setSelectedReportId(reportid))
    dispatch(setTenantWorkspace(workspacedetails))
    dispatch(setReportId(reportid))
    let reportDetails = { "workspaceId": workspacedetails, "reportId": reportid, "userId": user }
    const getReportDetails = await pbiReportDetails(reportDetails).unwrap()
    dispatch(setReportSelectedIndex(index))
    setTimeout(() => {
      dispatch(setSelectedReportDetails(getReportDetails))
      navigate('/home')
    }, 1000);
    // <ReportListSideBar reportid={reportid} workspacedetails={workspacedetails} index={index}/>

  }


  const handleAddUpdateFolderClose = () => {
    setOpenAddUpdateFolder(false);
    setRenameFolder(false);
  }

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        setIsMoveFolder(false);
        setFolderMoveDetails(null);
        setReportMoveDetails(null);
        setSelected([]);
        setMoveReport(false);
      }
    };
    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  const { searchTxt, setSearchTxt, folder } = props;

  const { searchFolderResult, searchReportResult } = useMemo(() => {
    let filteredFolderData = folderList;
    let filteredReportData = reportList;
    if (folder && searchTxt !== '') {
      const searchValue = searchTxt;
      filteredFolderData = filteredFolderData && filteredFolderData.length > 0 &&
        filteredFolderData.filter((row) => {
          return row.folderName && row.folderName !== null && row.folderName.toLowerCase().includes(searchValue.toLowerCase());
        })
    }
    if (folder && searchTxt !== '') {
      const searchValue = searchTxt;
      filteredReportData = filteredReportData && filteredReportData.length > 0 &&
        filteredReportData.filter((row) => {
          return row.name && row.name !== null && row.name.toLowerCase().includes(searchValue.toLowerCase());
        })
    }
    return {
      searchFolderResult: filteredFolderData && filteredFolderData.length > 0 ? filteredFolderData : [],
      searchReportResult: filteredReportData && filteredReportData.length > 0 ? filteredReportData : []
    };
  }, [searchTxt, folderList, reportList, folder]);

  const CheckIsParentFolder = (sourceFolderId, destinationFolderId) => {
    const folder = folderList && folderList.find(f => f.folderId === sourceFolderId);
    if (!folder) return false;

    const destinationFolder = folderList && folderList.find(f => f.folderId === destinationFolderId);
    if (!destinationFolder) {
      return false;
    }
    function isSubfolder(folderId) {
      const folder = folderList && folderList.find(f => f.folderId === folderId);
      if (!folder) return false; // Not found
      if (folder.folderId === sourceFolderId) return true; // Found as a subfolder
      return isSubfolder(folder.parentId);
    }
    if (isSubfolder(destinationFolderId)) {
      return false;
    }
    return true;
  }

  const menuItemsData = [
    {
      id: 1,
      name: 'Move Folder',
      condition: !isIdenticalFolder && isFolderClick && (currentContextFolder && currentContextFolder.folderId > 4),
      onClick: (e) => handleMoveFolderClick(e)
    }, {
      id: 2,
      name: 'Paste Folder',
      condition: !isIdenticalFolder && isFolderClick && folderMoveDetails && currentContextFolder &&
        (CheckIsParentFolder(folderMoveDetails.folderId, currentContextFolder.folderId)),
      onClick: (e) => handlePasteFolderClick(e)
    },
    {
      id: 3,
      name: 'Rename Folder',
      condition: !isIdenticalFolder && isFolderClick && (currentContextFolder && currentContextFolder.folderId > 4),
      onClick: (e) => handleRenameFolder(e)
    },
    {
      id: 4,
      name: 'Delete Folder',
      condition: !isIdenticalFolder && isFolderClick && (currentContextFolder && currentContextFolder.folderId > 4),
      onClick: (e) => handleDeleteFolderAlert(e)
    },
    {
      id: 5,
      name: 'Move Report',
      condition: isReportClick,
      onClick: (e) => handleMoveReportClick(e)
    },
    {
      id: 6,
      name: 'Delete Report',
      condition: isReportClick,
      onClick: (e) => handleDeleteReportAlertClick(e)
    },
    {
      id: 7,
      name: 'Paste Report',
      condition: reportMoveDetails && !isReportClick && (currentContextFolder && currentContextFolder.folderId > 0) || selected.length > 0,
      onClick: (e) => handlePasteReportClick(e)
    }
  ]

  const renderMenuItems = () => {
    let menuList = menuItemsData && menuItemsData.length > 0 && menuItemsData.filter((menu) => menu.condition)
    return (
      <>
        {menuList && menuList.map((menu, index) => {
          return (
            <>
              <MenuItem onClick={menu.onClick} key={index}>
                <ListItemIcon>
                  <DriveFileMoveIcon fontSize="small" />
                </ListItemIcon>
                {menu.name}
              </MenuItem>
              <Divider />
            </>
          )
        })}
      </>
    )
  }

  const handleCheckboxChange = (e, report) => {
    setReportMoveDetails(report);
    setSelected(prevSelectedIds => {
      if (prevSelectedIds.includes(report.reportId)) {
        return prevSelectedIds.filter(item => item !== report.reportId);
      } else {
        return [...prevSelectedIds, report.reportId];
      }
    })
  }

  return (
    props.folder ?
      <React.Fragment>

        {/* <br /> */}
        <div className="breadcrumbdiv" role="presentation">
          <Breadcrumbs aria-label="breadcrumb" style={{ paddingLeft: '5px' }}>
            <Link underline="hover" color="inherit" onClick={() => { setCurrentFolder(null); setFolderBreadCrum([]) }} >
              <HomeIcon sx={{ mr: 0.5 }} />
            </Link>
            {folderBreadCrum && (
              <>
                {folderBreadCrum.map((crumb, index) => {
                  return (
                    <>
                      {index + 1 != folderBreadCrum.length && (
                        <><Link
                          underline="hover"
                          color="inherit"
                          onClick={() => { setCurrentFolder(crumb); handleBreadCrumbClick(index) }}
                        >
                          {crumb.folderName}
                        </Link>
                          <span className="spansperator">/</span>
                        </>
                      )}
                      {index + 1 == folderBreadCrum.length && (
                        <Typography color="text.primary">{crumb.folderName}</Typography>
                      )}
                    </>
                  )
                })}
              </>
            )}
          </Breadcrumbs>
        </div>
        <div className="folderreportcontainer">
          <Box className="boxfoldercontent"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              alignContent: 'flex-start',
              p: 1,
              m: 1,
              // bgcolor: 'background.paper',
              height: 200,
              borderRadius: 1,
            }}>
            {folderList && folderList.length && (
              <>{searchFolderResult && searchFolderResult.length > 0 &&
                searchFolderResult.filter((folders) => {
                  if (searchTxt !== '') {
                    return folders
                  } else if (currentFolder) {
                    return folders.parentId == currentFolder.folderId
                  } else {
                    return folders.parentId == 0;
                  }
                }).map((folders, index) => {
                  return (
                    <Box
                      sx={{
                        p: 1,
                        m: 1,
                        bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : 'grey.100'),
                        color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
                        border: '1px solid',
                        borderColor: (theme) =>
                          theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                        borderRadius: 2,
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        cursor: 'pointer'
                      }}
                    >
                      <div
                        className="folderListContainer"
                        onClick={(e) => { setSearchTxt(''); setCurrentFolder(folders); handleFolderClick(e, folders) }} >
                        <FolderIcon className={folderMoveDetails && folderMoveDetails.folderId == folders.folderId ? 'alpha50' : ''} sx={{ fontSize: '20px', margin: '5px' }} />
                        <span className={folderMoveDetails && folderMoveDetails.folderId == folders.folderId ? 'alpha50 folderNameTxt' : 'folderNameTxt'}>{folders.folderName}</span>
                      </div>
                      {isAdminAnalytics && folders && folders.folderId <= 4 && (isMoveFolder || moveReport || selected.length > 0) ? <MoreVertIcon className="actionIcon" onClick={(e) => handleFolderAction(e, folders)} /> :
                        folderMoveDetails && folderMoveDetails.folderId === folders.folderId ? '' :
                          isAdminAnalytics && folders && folders.folderId > 4 ? <MoreVertIcon className="actionIcon" onClick={(e) => handleFolderAction(e, folders)} /> :
                            ''}
                    </Box>
                  )
                })}
                {isAdminAnalytics && folderBreadCrum.length > 0 && currentFolder.folderId != "4" && (
                  <Box
                    // onClick={(e) => { setIsFolderClick(false); setIsReportClick(false); handleClick(e) }}
                    sx={{
                      p: 1,
                      m: 1,
                      border: '1px solid',
                      borderColor: (theme) =>
                        theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                      borderRadius: 2,
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      textAlign: 'center',
                      display: 'flex',
                      cursor: 'pointer'
                    }}
                    aria-controls={open ? 'NewItem-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                  >
                    <div style={{ display: 'flex', flex: 1 }} onClick={(e) => handleOpenAddUpdateFolder(e)}>
                      <AddOutlinedIcon sx={{ fontSize: '20px', margin: '5px', display: 'flex', alignSelf: 'center' }} />
                      <span className="newFolderIcon">ADD</span>
                    </div>
                  </Box>
                )}
              </>
            )
            }

          </Box>
          <Box sx={{
            flexGrow: 1, pl: 2,
            display: 'flex', justifyContent: 'space-between', paddingTop: 0, paddingLeft: 0
          }}>
            <List >
              {reportList && currentFolder && (
                <>
                  {searchReportResult && searchReportResult.length > 0 &&
                    searchReportResult.filter((report) => {
                      if (searchTxt !== '') {
                        return report;
                      } else if (report.folderId == currentFolder.folderId) {
                        if (!report.name.toLowerCase().includes('_st_db_ecto_bi') && !report.name.toLowerCase().includes('paginated_') && !report.name.toLowerCase().includes('paginated-')) {
                          return report
                        }
                      }
                    }).map((report, index) => {
                      const labelId = `enhanced-report-checkbox-${index}`;
                      return <React.Fragment>
                        <div className="report-list-with-checkbox">
                          <Checkbox
                            checked={selected.includes(report.reportId)}
                            onChange={(e) => handleCheckboxChange(e, report)}
                            name="checkedReport"
                            color="primary"
                            inputProps={{
                              'aria-labelledby': labelId,
                            }}
                          />
                          <ListItemButton className="list-report" item xs={2} sm={4} md={4} key={index}
                            onClick={(e) => { setSearchTxt(''); handleReportClick(e, report) }}>
                            <ListItemText className={selected.includes(report.reportId) || (moveReport && reportMoveDetails && reportMoveDetails.reportId == report.reportId) ? 'itemreport alpha50' : 'itemreport'} onClick={() => handleOpenReportClick(report.reportId, pbiworkspace, report.reportId)}><SummarizeIcon className="reporticn" />{report.name}</ListItemText>
                            {isAdminAnalytics && selected.length <= 1 && <MoreVertIcon className="actionIcon" onClick={(e) => handleReportAction(e, report)} />}
                          </ListItemButton>
                        </div>
                      </React.Fragment>
                    })
                  }

                </>
              )}
            </List>
          </Box>
        </div>
        {menuItemsData && menuItemsData.length > 0 &&
          <Menu
            anchorEl={anchorEl}
            id="NewItem-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {renderMenuItems()}
          </Menu>
        }
        <AddUpdateFolder openAddUpdateFolder={openAddUpdateFolder} handleAddUpdateFolderClose={handleAddUpdateFolderClose} currentFolder={currentFolder} isSharedFolder={isSharedFolder} currentUserId={currentUserData ? currentUserData.id : ""}
          RenameFolder={RenameFolder} currentContextFolder={currentContextFolder} />
        <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseAlert}>
          <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
            Folder moved succussfully
          </Alert>
        </Snackbar>
        <Snackbar open={openSnackbarDelete} autoHideDuration={3000} onClose={handleCloseAlert}>
          <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
            Folder Deleted succussfully
          </Alert>
        </Snackbar>
        {spinnerLoad && (<Spinner />)}
        {openDialog && (<AlertDeleteDialog open={openDialog} close={handleDleteAlertClose}
          deleteReport={handleDeleteReport} deleteAction={deleteAction} deleteFolder={handleDeleteFolderClick} />)}
      </React.Fragment>
      : <div />
  );
}

export default FolderDashboard;
